import { getWindow } from '@hzdg/dom-utils';

export const getObjectForLocalStorageKey = <T>(key: string): T | null => {
  const window = getWindow();

  if (!window?.localStorage) return null;

  const currentCart = window.localStorage.getItem(key);

  if (!currentCart) return null;

  return JSON.parse(currentCart) as T;
};

export const setObjectForLocalStorageKey = <T extends Record<string, any>>(
  key: string,
  value: T,
) => {
  const window = getWindow();

  if (!window?.localStorage) return;

  window.localStorage.setItem(key, JSON.stringify(value));
};

export const removeObjectForLocalStorageKey = (key: string) => {
  const window = getWindow();

  if (!window?.localStorage) return;

  window.localStorage.removeItem(key);
};
